import { allTrailsApp, bmwApp, bumbleApp, chaseApp, cmbApp, coinbaseApp, discoverApp, farOutApp, fordApp, gaiaGPSApp, hingeApp, instaApp, linkedinApp, peakVisorApp, robinhoodApp, schwabApp, snapchatApp, teslaApp, tiktokApp, tinderApp, vanguardApp, xApp, youtubeApp } from "../assets/images";
import { RoutePath } from "../navigation/Routing";
import { IAppCard, IAppCardSection } from "../types";


export const socialMediaAppCovers: IAppCard[] = [
  {
    href: RoutePath.ComingSoon,
    image: instaApp,
    linkTitle: 'Instagram'
  },
  {
    href: RoutePath.ComingSoon,
    image: linkedinApp,
    linkTitle: 'LinkedIn'
  },
  {
    href: RoutePath.ComingSoon,
    image: snapchatApp,
    linkTitle: 'Snapchat'
  },
  {
    href: RoutePath.ComingSoon,
    image: tiktokApp,
    linkTitle: 'TikTok'
  },
  {
    href: RoutePath.ComingSoon,
    image: xApp,
    linkTitle: 'X'
  },
  {
    href: RoutePath.ComingSoon,
    image: youtubeApp,
    linkTitle: 'Youtube'
  }
];

export const datingAppCovers: IAppCard[] = [
  {
    href: RoutePath.ComingSoon,
    image: bumbleApp,
    linkTitle: 'Bumble'
  },
  {
    href: RoutePath.ComingSoon,
    image: cmbApp,
    linkTitle: 'CMB'
  },
  {
    href: RoutePath.ComingSoon,
    image: hingeApp,
    linkTitle: 'Hinge'
  },
  {
    href: RoutePath.ComingSoon,
    image: tinderApp,
    linkTitle: 'Tinder'
  }
];

export const wealthAppCovers : IAppCard[] = [
  {
    href: RoutePath.ComingSoon,
    image: robinhoodApp,
    linkTitle: 'Robin Hood'
  },
  {
    href: RoutePath.ComingSoon,
    image: coinbaseApp,
    linkTitle: 'Coin Base'
  },
  {
    href: RoutePath.ComingSoon,
    image: chaseApp,
    linkTitle: 'Chase'
  },
  {
    href: RoutePath.ComingSoon,
    image: discoverApp,
    linkTitle: 'Discover'
  },
  {
    href: RoutePath.ComingSoon,
    image: schwabApp,
    linkTitle: 'Schwab'
  },
  {
    href: RoutePath.ComingSoon,
    image: vanguardApp,
    linkTitle: 'Vanguard'
  }
];

export const natureAppCovers : IAppCard[] = [
  {
    href: RoutePath.ComingSoon,
    image: allTrailsApp,
    linkTitle: 'All Trails'
  },
  {
    href: RoutePath.ComingSoon,
    image: gaiaGPSApp,
    linkTitle: 'Gaia GPS'
  },
  {
    href: RoutePath.ComingSoon,
    image: peakVisorApp,
    linkTitle: 'Peak Visor'
  },
  {
    href: RoutePath.ComingSoon,
    image: farOutApp,
    linkTitle: 'Far Out'
  }
];

export const eVAppCovers : IAppCard[] = [
  {
    href: RoutePath.ComingSoon,
    image: bmwApp,
    linkTitle: 'BMW'
  },
  {
    href: RoutePath.ComingSoon,
    image: fordApp,
    linkTitle: 'Ford'
  },
  {
    href: RoutePath.ComingSoon,
    image: teslaApp,
    linkTitle: 'Tesla'
  }
];

export const healthAppCovers : IAppCard[] = [];

export const noteTakingAppCovers : IAppCard[] = [];

export const appReviewCovers: IAppCardSection[] = [{
  title: 'Social Media',
  cards: socialMediaAppCovers
},{
  title: 'Dating',
  cards: datingAppCovers
},{
  title: 'Wealth',
  cards: wealthAppCovers
},{
  title: 'Nature',
  cards: natureAppCovers
},{
  title: 'EV',
  cards: eVAppCovers
},
{
  title: 'Health',
  cards: healthAppCovers
},{
  title: 'Note taking',
  cards: noteTakingAppCovers
}
]